import Page from "components/common/layout/Page";
import { FeatureRequest } from "interfaces/feature-request";
import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import styled from "styled-components";
import { getIdToken } from "services/auth/auth";
import LoadingIndicator from "../../components/common/ui/LoadingIndicator/LoadingIndicator";
import FeatureRequestsList from "./FeatureRequestsList";
import useQuery from "hooks/common/useQuery/useQuery";
import FeatureRequestDetails from "./FeatureRequestDetails";
import useFetch from "hooks/common/useFetch/useFetch";

const LoadingWrapper = styled.div`
    padding-top: 20rem;
    position: relative;
`;

const FeatureRequestsPage: React.FC = () => {
    const { featureRequestId } = useQuery(["featureRequestId"]);
    const history = useHistory();
    const location = useLocation();
    const token = useSelector(getIdToken);

    const {
        data: featureRequests,
        loading: featureRequestsLoading,
        error: featureRequestsError,
        fetchData: fetchFeatureRequests,
    } = useFetch<FeatureRequest[]>();

    const {
        data: featureRequest,
        loading: featureRequestLoading,
        error: featureRequestError,
        fetchData: fetchFeatureRequest,
        setData: setFeatureRequest,
    } = useFetch<FeatureRequest>();

    const loading = featureRequestsLoading || featureRequestLoading;
    const error = featureRequestsError || featureRequestError;

    useEffect(() => {
        if (!token) {
            history.replace("/");
        }
    }, [token, history]);

    useEffect(() => {
        fetchFeatureRequests("/api/feature-requests");
    }, [fetchFeatureRequests]);

    useEffect(() => {
        if (featureRequestId) {
            fetchFeatureRequest(`/api/feature-requests/${featureRequestId}`);
        } else {
            setFeatureRequest(null);
        }
    }, [featureRequestId, fetchFeatureRequest, setFeatureRequest]);

    return (
        <Page>
            {error && <p>{error}</p>}
            {loading && (
                <LoadingWrapper>
                    <LoadingIndicator isLoading={loading} />
                </LoadingWrapper>
            )}
            {!!featureRequest && !loading && !error && (
                <FeatureRequestDetails
                    onBack={() => history.replace(location.pathname)}
                    featureRequest={featureRequest}
                />
            )}
            <FeatureRequestsList
                featureRequests={featureRequests || []}
                visible={!featureRequestId && !loading && !error}
            />
        </Page>
    );
};

export default FeatureRequestsPage;
